<template>
  <div>
    <div v-if="readonly">
      <el-input
        :value="initialProfession"
        placeholder="Profession (Select one)"
        type="text"
        name="profession"
        readonly
      ></el-input>
    </div>
    <el-select
      v-else
      v-model="selected"
      placeholder="Profession (Select one)"
      name="profession"
      @change="handleChange"
    >
      <el-option
        v-for="profession in professions"
        :key="profession.id"
        :label="profession.name"
        :value="profession.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import store from "../store";

export default {
  props: {
    initial: {
      type: String,
    },
    excludes: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selected: this.initial,
    };
  },

  computed: {
    professions() {
      return (
        this.$store.state.profession.items.length &&
        this.$store.state.profession.items
        .filter((profession) => this.excludes.indexOf(profession.name) < 0)
        .sort((a, b) => a.name.localeCompare(b.name))
      );
    },

    device() {
      return this.$store.getters["ui/getDevice"];
    },

    initialProfession() {
      if (this.initial && this.professions.length) {
        return this.professions.find((profession) => profession.id === this.initial).name;
      }
      return "";
    },
  },

  methods: {
    handleChange(profession) {
      this.$emit("change", profession);
    },
  },

  created() {
    !this.$store.state.profession && this.$store.registerModule("profession", store);

    this.$store.dispatch("profession/getAllProfessions");
  },

  watch: {
    initial(profession) {
      this.selected = profession;
    },
  },
};
</script>
